import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ClienteService } from 'src/app/aplicaciones-modulos/balanza/services/cliente.service';

@Component({
  selector: 'app-cambio-presupuesto',
  templateUrl: './cambio-presupuesto.component.html',
  styleUrls: ['./cambio-presupuesto.component.css']
})
export class CambioPresupuestoComponent implements OnInit {

  formulario: FormGroup;
  cmbMeses: { clave: number; valor: string; }[];
  cmbAnios: any[] = []; modulo: any;
  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  listaVacia: boolean = true;
  loading: boolean = false;
  //buscador grid
  textoBuscar: string;

  constructor(
    private fb: FormBuilder,
    private _indicadores: IndicadoresVivosService,
    private _utils: UtilsService,
    private _catalogo: CatalogoIndicadoresService,
  ) { }

  ngOnInit() {
    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cmbMeses = this._catalogo.catalogoMeses();
    this.cmbAnios = this._catalogo.catalogoAnio();
    this.formulario = this.fb.group({
      anio: ['', [Validators.required]],//2022,
      mesInicio: ['', [Validators.required]],//1,
      mesFinal: ['', [Validators.required]],//3,
      vendedorOrigen: ['', [Validators.required]],//905076,
      vendedorDestino: ['', [Validators.required]],//100006
      nombreVendedorOrigen: ['', []],
      nombreVendedorDestino: ['', []]
    });
    this.cargarGrid();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'Año',
        field: 'anio',
        filter: true,
        width: 120,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Canal',
        field: 'tipo',
        sortable: true,
        width: 160,
        filter: true,
        valueGetter: function(params) {
          return (params.data.tipo == 1) ? 'CANAL MODERNO' : 'CANAL TRADICIONAL';
        }
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cod.Vendedor',
        field: 'codigoVendedor',
        sortable: true,
        width: 150,
        filter: true,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nom.Vendedor',
        field: 'nombreVendedor',
        sortable: true,
        width: 250,
        filter: true,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cod.Vendedor Destino',
        field: 'codigoVendedorDestino',
        sortable: true,
        width: 150,
        filter: true,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nom.Vendedor Destino',
        field: 'vendedorDestino',
        sortable: true,
        width: 250,
        filter: true,
        cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cod.Cliente',
        field: 'codigoCliente',
        sortable: true,
        filter: true,
        width: 150,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nom.Cliente',
        field: 'nombreCliente',
        sortable: true,
        filter: true,
        width: 250,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cod.Articulo',
        sortable: true,
        filter: true,
        width: 220,
        valueGetter: function(params) {
          let codigoArticulo = params.data.codigoArticulo;
          let contenedor = params.data.contenedor;
          if ((codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") ) {
            return `${codigoArticulo}/${contenedor}`
          } else {
            if (codigoArticulo !== undefined) {
              return `${codigoArticulo}`;
            } else {
              return '';
            }
          }
        }
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Articulo',
        field: 'nombreArticulo',
        sortable: true,
        filter: true,
        width: 300,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cajas',
        field: 'cajas',
        sortable: true,
        width: 180,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Kilos',
        field: 'kilos',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Dolares',
        field: 'dolares',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'MTV',
        field: 'mtv',
        sortable: true,
        width: 170,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  changeCellColor(params) {
    let data = params.colDef.field;
    let css = "";

    if (data != undefined){
      if (data === 'codigoVendedor' || data === 'nombreVendedor') {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-size': '14px'
        };
      }else{
        return {
          'background-color': '#90ee90',
          'color': 'black',
          'font-size': '14px'
        };
      }
    }else{
        return "";
    }
  
  }

  getVendedorOrigen() {
    this.loading = true;
    if (this.formulario.get("vendedorOrigen").value != null && this.formulario.get("vendedorOrigen").value.length > 0) {
      this._indicadores.getVendedor(this.formulario.get("vendedorOrigen").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedorOrigen'].setValue(resp.nombreVendedor1);
          } else {
            this.formulario.controls['nombreVendedorOrigen'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedorOrigen'].setValue('');
        }
      );
    }
  }

  getVendedorDestino() {
    this.loading = true;
    if (this.formulario.get("vendedorDestino").value != null && this.formulario.get("vendedorDestino").value.length > 0) {
      this._indicadores.getVendedor(this.formulario.get("vendedorDestino").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedorDestino'].setValue(resp.nombreVendedor1);
          } else {
            this.formulario.controls['nombreVendedorDestino'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedorDestino'].setValue('');
        }
      );
    }
  }

  getChangePresupuestoVenta() {
    this.loading = true;
    this._indicadores.getChangePresupuestoVenta(this.formulario.value).subscribe((res: any) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this._utils.mensajeErroToast(err.error.message);
      this.rowData = [];
    });
  }

  guardar() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.cambiarPresupuesto,
        text: '',
        action: this.DAT_BTNS.cambiarPresupuesto,
        funcion: this._indicadores.changeVendedorPresupuesto(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.listaVacia = true;
      this.rowData = [];
    }).catch((err) => {
      console.log(err.error.message);
    });
  }

  onChangeVendedorOrigen(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.formulario.get("vendedorOrigen").value != null && this.formulario.get("vendedorOrigen").value.length > 0) {
      this._indicadores.getVendedor(this.formulario.get("vendedorOrigen").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedorOrigen'].setValue(resp.nombreVendedor1);
          } else {
            this.formulario.controls['nombreVendedorOrigen'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedorOrigen'].setValue('');
        }
      );
    }
  }

  onChangeVendedorDestino(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.formulario.get("vendedorDestino").value != null && this.formulario.get("vendedorDestino").value.length > 0) {
      this._indicadores.getVendedor(this.formulario.get("vendedorDestino").value).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedorDestino'].setValue(resp.nombreVendedor1);
          } else {
            this.formulario.controls['nombreVendedorDestino'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedorDestino'].setValue('');
        }
      );
    }
  }

}
